<script lang="ts">
  import type { MapIcon } from "../../types";

  export let icons: MapIcon[] = [];

  $: valid = icons.filter((icon) => icon.src);
</script>

{#each valid as icon}
  <svg
    width={icon.size}
    height={icon.size}
    viewBox="0 0 {icon.size} {icon.size}"
    style="--x: {icon.x}px; --y: {icon.y}px; --rotation: {icon.rotation}deg;"
  >
    {#if icon.color}
      <mask id="mask-icon-{icon.id}">
        <image href={icon.src} width={icon.size} />
      </mask>

      <rect
        fill={icon.color}
        mask="url(#mask-icon-{icon.id})"
        width={icon.size}
        height={icon.size}
      />
    {:else}
      <image href={icon.src} width={icon.size} />
    {/if}
  </svg>
{/each}

<style>
  svg {
    position: absolute;
    top: var(--y);
    left: var(--x);
    transform: rotate(var(--rotation, 0deg));
    transform-origin: 0 0;
  }

  mask {
    mask-type: alpha;
  }
</style>
